import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-049bfadd")

_pushScopeId("data-v-049bfadd")
const _hoisted_1 = {
  key: 0,
  class: "suggestions"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_textarea = _resolveComponent("ion-textarea")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_item = _resolveComponent("ion-item")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.responses && _ctx.showSuggestions)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.responses, (response) => {
            return (_openBlock(), _createBlock(_component_ion_button, {
              onClick: $event => (_ctx.sendMessage(response)),
              key: response,
              textContent: response,
              fill: "outline",
              class: "suggestion"
            }, null, 8, ["onClick", "textContent"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("", true),
    _createVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.sendCustomMessage(...args)), ["prevent"]))
    }, [
      _createVNode(_component_ion_item, null, {
        default: _withId(() => [
          _createVNode(_component_ion_textarea, {
            modelValue: _ctx.message,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.message = $event)),
            autofocus: true,
            enterkeyhint: "send",
            wrap: "off",
            rows: "1",
            placeholder: "Custom Response",
            onKeypress: _withKeys(_withModifiers(_ctx.sendCustomMessage, ["prevent"]), ["enter"])
          }, null, 8, ["modelValue", "onKeypress"]),
          _createVNode(_component_ion_icon, {
            slot: "end",
            icon: "/assets/icons/keyboard.svg"
          })
        ]),
        _: 1
      })
    ], 32)
  ]))
})